@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  --background: #000306;
  --surface: #020810;
  --surface-elevated: #050f1e;
  --border: #0c2038;
  --accent-cyan: #00d4ff;
  --accent-teal: #00ff88;
  --accent-amber: #ffaa00;
  --accent-red: #ff4466;
  --accent-purple: #aa44ff;
  --text-primary: #d4ecfa;
  --text-secondary: #6b97b8;
  --text-muted: #284060;

  color-scheme: dark;
  color: var(--text-primary);
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: #000306;
  color: var(--text-primary);
  font-family: 'IBM Plex Mono', ui-monospace, SFMono-Regular, Menlo, monospace;
}

body {
  background-color: #000306;
  background-image:
    radial-gradient(1px 1px at 1% 5%, rgba(255, 255, 255, 0.9), transparent 2px),
    radial-gradient(0.5px 0.5px at 3% 22%, rgba(220, 235, 255, 0.5), transparent 1px),
    radial-gradient(1.25px 1.25px at 7% 48%, rgba(255, 255, 255, 0.8), transparent 2px),
    radial-gradient(1px 1px at 6% 67%, rgba(255, 245, 220, 0.7), transparent 2px),
    radial-gradient(0.75px 0.75px at 4% 83%, rgba(255, 255, 255, 0.55), transparent 2px),
    radial-gradient(1px 1px at 8% 93%, rgba(220, 235, 255, 0.85), transparent 2px),
    radial-gradient(1.5px 1.5px at 12% 8%, rgba(255, 255, 255, 0.65), transparent 3px),
    radial-gradient(1px 1px at 14% 35%, rgba(255, 245, 220, 0.7), transparent 2px),
    radial-gradient(0.75px 0.75px at 11% 58%, rgba(220, 235, 255, 0.45), transparent 2px),
    radial-gradient(1.25px 1.25px at 16% 77%, rgba(255, 255, 255, 0.85), transparent 2px),
    radial-gradient(0.5px 0.5px at 19% 14%, rgba(255, 245, 220, 0.5), transparent 1px),
    radial-gradient(1px 1px at 22% 28%, rgba(255, 255, 255, 0.75), transparent 2px),
    radial-gradient(1.75px 1.75px at 24% 46%, rgba(220, 235, 255, 0.8), transparent 3px),
    radial-gradient(0.75px 0.75px at 21% 68%, rgba(255, 255, 255, 0.55), transparent 2px),
    radial-gradient(1px 1px at 26% 88%, rgba(255, 245, 220, 0.65), transparent 2px),
    radial-gradient(1.25px 1.25px at 30% 5%, rgba(220, 235, 255, 0.9), transparent 2px),
    radial-gradient(0.5px 0.5px at 33% 26%, rgba(255, 255, 255, 0.4), transparent 1px),
    radial-gradient(1px 1px at 31% 52%, rgba(255, 255, 255, 0.75), transparent 2px),
    radial-gradient(1.5px 1.5px at 35% 71%, rgba(255, 245, 220, 0.8), transparent 3px),
    radial-gradient(0.75px 0.75px at 38% 90%, rgba(220, 235, 255, 0.5), transparent 2px),
    radial-gradient(1px 1px at 42% 12%, rgba(255, 255, 255, 0.85), transparent 2px),
    radial-gradient(0.75px 0.75px at 44% 32%, rgba(255, 245, 220, 0.45), transparent 2px),
    radial-gradient(2px 2px at 46% 58%, rgba(220, 235, 255, 0.95), transparent 3px),
    radial-gradient(1px 1px at 43% 80%, rgba(255, 255, 255, 0.7), transparent 2px),
    radial-gradient(0.5px 0.5px at 48% 93%, rgba(255, 245, 220, 0.4), transparent 1px),
    radial-gradient(1.5px 1.5px at 52% 18%, rgba(255, 255, 255, 0.8), transparent 3px),
    radial-gradient(1px 1px at 55% 40%, rgba(220, 235, 255, 0.65), transparent 2px),
    radial-gradient(0.75px 0.75px at 58% 65%, rgba(255, 245, 220, 0.5), transparent 2px),
    radial-gradient(1.25px 1.25px at 56% 88%, rgba(255, 255, 255, 0.85), transparent 2px),
    radial-gradient(1px 1px at 62% 7%, rgba(220, 235, 255, 0.7), transparent 2px),
    radial-gradient(0.75px 0.75px at 65% 24%, rgba(255, 245, 220, 0.45), transparent 2px),
    radial-gradient(1.5px 1.5px at 68% 48%, rgba(255, 255, 255, 0.9), transparent 3px),
    radial-gradient(1px 1px at 64% 72%, rgba(220, 235, 255, 0.65), transparent 2px),
    radial-gradient(0.5px 0.5px at 70% 91%, rgba(255, 245, 220, 0.35), transparent 1px),
    radial-gradient(1.25px 1.25px at 74% 15%, rgba(255, 255, 255, 0.8), transparent 2px),
    radial-gradient(1px 1px at 76% 38%, rgba(220, 235, 255, 0.7), transparent 2px),
    radial-gradient(0.75px 0.75px at 79% 60%, rgba(255, 245, 220, 0.5), transparent 2px),
    radial-gradient(1.5px 1.5px at 77% 83%, rgba(255, 255, 255, 0.85), transparent 3px),
    radial-gradient(1px 1px at 83% 9%, rgba(220, 235, 255, 0.65), transparent 2px),
    radial-gradient(0.5px 0.5px at 86% 30%, rgba(255, 255, 255, 0.4), transparent 1px),
    radial-gradient(1.25px 1.25px at 88% 54%, rgba(255, 245, 220, 0.7), transparent 2px),
    radial-gradient(1px 1px at 84% 76%, rgba(255, 255, 255, 0.6), transparent 2px),
    radial-gradient(0.75px 0.75px at 89% 95%, rgba(220, 235, 255, 0.5), transparent 2px),
    radial-gradient(1.5px 1.5px at 93% 14%, rgba(255, 255, 255, 0.9), transparent 3px),
    radial-gradient(1px 1px at 96% 41%, rgba(255, 245, 220, 0.55), transparent 2px),
    radial-gradient(0.75px 0.75px at 92% 68%, rgba(220, 235, 255, 0.45), transparent 2px),
    radial-gradient(1.25px 1.25px at 98% 87%, rgba(255, 255, 255, 0.75), transparent 2px),
    radial-gradient(ellipse at top, rgba(15, 32, 64, 0.35), transparent 60%),
    radial-gradient(ellipse at bottom, rgba(10, 22, 40, 0.7), transparent 70%);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

body::before,
body::after {
  content: '';
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: -1;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

body::before {
  background-image:
    radial-gradient(1.5px 1.5px at 15% 18%, rgba(255, 255, 255, 0.95), transparent 3px),
    radial-gradient(1px 1px at 38% 42%, rgba(220, 235, 255, 0.9), transparent 2px),
    radial-gradient(2px 2px at 60% 70%, rgba(255, 255, 255, 0.95), transparent 3px),
    radial-gradient(1.25px 1.25px at 82% 30%, rgba(255, 245, 220, 0.85), transparent 2px),
    radial-gradient(1px 1px at 25% 85%, rgba(255, 255, 255, 0.9), transparent 2px),
    radial-gradient(1.5px 1.5px at 72% 12%, rgba(220, 235, 255, 0.9), transparent 3px);
  animation: twinkle 3.2s ease-in-out infinite;
}

body::after {
  background-image:
    radial-gradient(1.5px 1.5px at 50% 15%, rgba(255, 255, 255, 0.9), transparent 3px),
    radial-gradient(1px 1px at 72% 55%, rgba(220, 235, 255, 0.85), transparent 2px),
    radial-gradient(1.25px 1.25px at 18% 62%, rgba(255, 245, 220, 0.85), transparent 2px),
    radial-gradient(1px 1px at 90% 82%, rgba(255, 255, 255, 0.9), transparent 2px),
    radial-gradient(0.75px 0.75px at 35% 8%, rgba(220, 235, 255, 0.85), transparent 2px),
    radial-gradient(1.5px 1.5px at 8% 40%, rgba(255, 255, 255, 0.9), transparent 3px);
  animation: twinkle 4.8s ease-in-out 1.2s infinite;
}

@keyframes twinkle {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.25;
  }
}

#root {
  height: 100%;
  width: 100%;
  overflow: hidden;
  animation: fadeIn 1s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.header-scan-bar::after {
  content: '';
  position: absolute;
  top: auto;
  bottom: -9px;
  width: 300px;
  height: 20px;
  background: radial-gradient(
    ellipse at center,
    rgba(0, 212, 255, 0.6) 0%,
    rgba(0, 212, 255, 0.2) 40%,
    transparent 70%
  );
  pointer-events: none;
  animation: headerScan 6s ease-in-out infinite;
}

@keyframes headerScan {
  0% { left: -150px; opacity: 0; }
  5% { opacity: 1; }
  95% { opacity: 1; }
  100% { left: calc(100% + 150px); opacity: 0; }
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: var(--surface);
}

::-webkit-scrollbar-thumb {
  background: var(--border);
  border-radius: 4px;
  border: 1px solid var(--surface);
}

::-webkit-scrollbar-thumb:hover {
  background: var(--accent-cyan);
  box-shadow: 0 0 6px rgba(0, 212, 255, 0.6);
}

::-webkit-scrollbar-corner {
  background: var(--surface);
}

* {
  scrollbar-width: thin;
  scrollbar-color: var(--border) var(--surface);
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.4);
  }
}

.planet-hz-pulse {
  transform-box: fill-box;
  transform-origin: center;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes compareSlideIn {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.compare-slide-in {
  animation: compareSlideIn 350ms ease-out;
}

@keyframes compareSlideOut {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
}

.compare-slide-out {
  animation: compareSlideOut 300ms ease-in forwards;
}

@keyframes badgeFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.badge-fade-in {
  animation: badgeFadeIn 200ms ease-out both;
}

@keyframes starPulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
}

.star-pulse {
  display: inline-block;
  animation: starPulse 2s ease-in-out infinite;
}

@keyframes featuredBadgePulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
}

.featured-badge-pulse {
  animation: featuredBadgePulse 2s ease-in-out infinite;
  transform-origin: center;
}

@keyframes countFadeIn {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.count-fade-in {
  animation: countFadeIn 400ms ease-out both;
}

input[type='range'] {
  -webkit-appearance: auto;
  appearance: auto;
  accent-color: #00d4ff;
  cursor: pointer;
  width: 100%;
}

.control-btn {
  box-shadow: 0 0 6px rgba(0, 212, 255, 0.2),
    inset 0 0 8px rgba(0, 212, 255, 0.08);
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.6);
  transition: box-shadow 200ms ease-out, text-shadow 200ms ease-out,
    color 200ms ease-out, border-color 200ms ease-out,
    background-color 200ms ease-out;
}

.control-btn:hover {
  border-color: #00d4ff;
  box-shadow: 0 0 16px rgba(0, 212, 255, 0.7),
    0 0 4px rgba(0, 212, 255, 0.9),
    inset 0 0 10px rgba(0, 212, 255, 0.1);
  text-shadow: 0 0 14px rgba(0, 212, 255, 0.9);
}

@keyframes loadingStar {
  0% { opacity: 0; }
  25% { opacity: 1; }
  75% { opacity: 1; }
  100% { opacity: 0; }
}

@keyframes portraitFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes portraitFadeOut {
  from { opacity: 1; }
  to { opacity: 0; }
}

@keyframes skeletonProgressFill {
  from { transform: translateX(-100%); }
  to { transform: translateX(0%); }
}

.skeleton-progress {
  width: 100%;
  background: linear-gradient(
    90deg,
    rgba(0, 212, 255, 0) 0%,
    rgba(0, 212, 255, 0.6) 40%,
    #00d4ff 100%
  );
  box-shadow: 0 0 10px rgba(0, 212, 255, 0.6);
  transform: translateX(-100%);
  animation: skeletonProgressFill 3s ease-out forwards;
}

@keyframes loadBarFill {
  0% { width: 0%; }
  100% { width: 100%; }
}

.load-bar-fill {
  width: 0%;
  background: linear-gradient(
    90deg,
    rgba(0, 212, 255, 0.4) 0%,
    #00d4ff 60%,
    #7ee8ff 100%
  );
  box-shadow: 0 0 12px rgba(0, 212, 255, 0.9), 0 0 4px rgba(0, 212, 255, 0.7);
  animation: loadBarFill 3s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

@keyframes titlePulse {
  0%, 100% {
    opacity: 0.92;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.02);
  }
}

.title-pulse {
  animation: titlePulse 2.4s ease-in-out infinite;
  transform-origin: center;
  will-change: transform, opacity;
}

@keyframes toastInOut {
  0% { opacity: 0; transform: translate(-50%, -8px); }
  10% { opacity: 1; transform: translate(-50%, 0); }
  90% { opacity: 1; transform: translate(-50%, 0); }
  100% { opacity: 0; transform: translate(-50%, -8px); }
}
.toast-anim {
  animation: toastInOut 2.5s ease-out forwards;
}

@keyframes countFlash {
  0% { color: var(--text-muted); }
  50% { color: var(--accent-cyan); transform: scale(1.1); }
  100% { color: var(--text-muted); }
}
.count-flash {
  animation: countFlash 0.4s ease-out;
  display: inline-block;
}

.music-volume-slider {
  -webkit-appearance: none;
  appearance: none;
  width: 80px;
  height: 4px;
  background: var(--border);
  border-radius: 2px;
  outline: none;
  cursor: pointer;
  vertical-align: middle;
}
.music-volume-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--accent-cyan);
  box-shadow: 0 0 6px rgba(0, 212, 255, 0.7);
  cursor: pointer;
}
.music-volume-slider::-moz-range-thumb {
  width: 12px;
  height: 12px;
  border: none;
  border-radius: 50%;
  background: var(--accent-cyan);
  box-shadow: 0 0 6px rgba(0, 212, 255, 0.7);
  cursor: pointer;
}

.music-eq {
  display: inline-flex;
  align-items: flex-end;
  gap: 2px;
  height: 10px;
  width: 12px;
}
.music-eq span {
  display: block;
  width: 2px;
  background: var(--accent-cyan);
  box-shadow: 0 0 4px rgba(0, 212, 255, 0.6);
  animation: musicEq 0.9s ease-in-out infinite;
}
.music-eq span:nth-child(1) { animation-delay: 0s; }
.music-eq span:nth-child(2) { animation-delay: 0.15s; }
.music-eq span:nth-child(3) { animation-delay: 0.3s; }

@keyframes musicEq {
  0%, 100% { height: 30%; }
  50% { height: 100%; }
}

@keyframes suggestionsFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
.suggestions-fade-in {
  animation: suggestionsFadeIn 0.15s ease-out;
}
